import { VisibilityChange } from './VisibilityChange'

export const visibilityChangeService = {
  sockets: new VisibilityChange({ timer: 1000 * 60 }),
  myOrders: new VisibilityChange({ timer: 1000 * 5 }),
  stable: new VisibilityChange({ timer: 1000 * 5 }),
}
